module.exports = __webpack_public_path__ + "static/img/activity1.ea54cfa1.png";